import auth0 from "auth0-js";

import history from "./history";

export default class Auth {
  // Please use your own credentials here
  auth0 = new auth0.WebAuth({
    domain: "dev-tkbvwv-x.eu.auth0.com",
    clientID: "QtDNoEUwO6fISopx5HyMhnjPVLIfjgmC",
    // redirectUri: "http://localhost:3000/venect/callback",
    redirectUri: "http://iot.research.hamk.fi/venect/callback",
    audience: "https://dev-tkbvwv-x.eu.auth0.com/userinfo",
    responseType: "token id_token",
    scope: "openid",
  });

  login = () => {
    this.auth0.authorize();
  };

  // parses the result after authentication from URL hash
  handleAuthentication = () => {
    this.auth0.parseHash((err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        this.setSession(authResult);
        history.replace("/venect/remote-control");
      } else if (err) {
        history.replace("/venect/remote-control");
        console.log(err);
      }
    });
  };

  // Sets user details in localStorage
  setSession = (authResult) => {
    // Set the time that the access token will expire at
    let expiresAt = JSON.stringify(
      authResult.expiresIn * 1000 + new Date().getTime()
    );
    localStorage.setItem("access_token", authResult.accessToken);
    localStorage.setItem("id_token", authResult.idToken);
    localStorage.setItem("expires_at", expiresAt);
    // navigate to the venect route
    history.replace("/venect");
  };

  // removes user details from localStorage
  logout = () => {
    // Clear access token and ID token from local storage
    localStorage.removeItem("access_token");
    localStorage.removeItem("id_token");
    localStorage.removeItem("expires_at");
    // navigate to the venect route
    history.replace("/venect/remote-control");
    // const Http = new XMLHttpRequest();
    // const url1 =
    //   "https://dev-tkbvwv-x.eu.auth0.com/v2/logout?returnTo=http%3A%2F%2Fiot.research.hamk.fi/venect/login";
    // const url = "https://dev-tkbvwv-x.eu.auth0.com/v2/logout?federated";
    // Http.open("POST", url);
    // Http.send();
    // Http.open("POST", url1);
    // Http.send();
  };

  // checks if the user is authenticated
  isAuthenticated = () => {
    // Check whether the current time is past the
    // access token's expiry time
    console.log(localStorage.getItem("access_token"));
    console.log(localStorage.getItem("id_token"));
    console.log(localStorage.getItem("expires_at"));
    let expiresAt = JSON.parse(localStorage.getItem("expires_at"));
    return new Date().getTime() < expiresAt;
  };
}
